<div
    class="auth-screen-wrapper flex min-w-0 flex-auto flex-col items-center sm:flex-row sm:justify-center md:items-start md:justify-start add-padding"
>
    <div
        class="auth-left-side-image-box relative hidden h-full w-1/2 flex-auto items-center justify-center  overflow-hidden p-16 dark:border-l md:flex lg:px-28 img-bg card-left-side-radius"
    >
                <div class="auth-left-side-image relative z-10 w-full max-w-2xl">
                    <img src="grimmorLogo.svg" class="scale-[2]" alt="logo"/>
                </div>
    </div>
    <div class="auth-right-side-content w-full px-4 py-8 sm:bg-card sm:w-auto sm:p-12 sm:shadow md:flex md:h-full md:w-1/2 md:items-center justify-center  md:p-16 md:shadow-none card-right-side-radius">
        <div class="auth-content-inner mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
            <!-- Logo -->
            <div class="w-50">
            </div>

            <!-- Title -->
            <div class="xxl:mt-8 text-4xl font-extrabold leading-tight tracking-tight">
                {{LABELS.FORGOT_PASSWORD}}
<!--                <img src="grimmor-image.png" class="img-wrapper"/>-->
            </div>
            <!-- Sign in form -->
            <form #forgotPasswordNgForm="ngForm" [formGroup]="forgotPasswordForm" class="mt-8">
                <!-- Email field -->
                <mat-form-field class="w-full" floatLabel="always">
                    <mat-label>{{LABELS.EMAIL_ADDRESS}}</mat-label>
                    <input [formControlName]="'email'" id="email" matInput [placeholder]="LABELS.ENTER_EMAIL_ADDRESS"/>
                    @if (forgotPasswordForm.get('email').hasError('required')) {
                        <mat-error> {{LABELS.EMAIL_REQUIRED}}</mat-error>
                    }
                    @if (forgotPasswordForm.get('email').hasError('email')) {
                        <mat-error>
                            {{LABELS.VALID_EMAIL}}
                        </mat-error>
                    }
                </mat-form-field>
                <button
                    (click)="sendResetLink()"
                    [disabled]="forgotPasswordForm.disabled"
                    class="fuse-mat-button-large mt-6 w-full btn-theme-color"
                    mat-flat-button
                >
                    @if (!forgotPasswordForm.disabled) {
                        <span> {{LABELS.CONTINUE}} </span>
                    }
                    @if (forgotPasswordForm.disabled) {
                        <mat-progress-spinner
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>
                <div class="mt-8 text-md font-medium flex justify-end">
                    <a
                        [routerLink]="_router.url.indexOf('/partner/') !== -1  ? ['/partner'] : ['/']"
                        class="ml-1 theme-color hover:underline"
                    >{{LABELS.RETURN_TO}} {{LABELS.SING_IN}}
                    </a>
                </div>
            </form>
        </div>
    </div>
</div>
